import React from "react";
import engina from "../img/engina.webp";
import chef from "../img/syf.webp";
import designer from "../img/designer.webp";
import "../css/nameinput.css"; // 必要なら別途ヘッダー用CSSに分けてもOK

function Header() {
  return (
    <header className="common-header">
      <h1>適職診断へようこそ</h1>
      <div className="icon-area">
        <ul>
          <li><img src={engina} alt="engineer" /><p>engineer</p></li>
          <li><img src={chef} alt="chef" /><p>chef</p></li>
          <li><img src={designer} alt="designer" /><p>designer</p></li>
        </ul>
      </div>
    </header>
  );
}

export default Header;
